import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"mt-10 green-text"},[_vm._v("Not sure if your credit card works? Give it a quick test below")]),_c('div',{staticClass:"d-flex justify-center"},[_c(VBtn,{attrs:{"color":"green"},on:{"click":_vm.onBuy}},[_c('span',{staticClass:"white--text"},[_vm._v("Test with $0.99")])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }